<h1 class="pb-5 font-brand text-28px font-bold text-neutral-800">
  {{ 'como.create-or-link-account.identification-step.title' | translate }}
</h1>

<form
  [formGroup]="form"
  class="pb-6"
>
  <ng-container *ngIf="identificationType() === 'phoneNumber'">
    <label
      for="phoneOrEmail"
      class="mb-1 block font-base text-sm font-normal leading-5 text-neutral-600"
      translate="signup.phone"
    ></label>
    <label
      for="phoneOrEmail"
      class="mb-2 block font-base text-xs font-normal text-neutral-500"
    >
      {{ 'como.help-phone-format' | translate }}
    </label>
  </ng-container>
  <ng-container *ngIf="identificationType() === 'email'">
    <label
      for="phoneOrEmail"
      class="mb-1 block font-base text-sm font-normal leading-5 text-neutral-600"
      translate="signup.email"
    ></label>
    <label
      for="phoneOrEmail"
      class="mb-2 block font-base text-xs font-normal text-neutral-500"
    >
      {{ 'como.help-email-format' | translate }}
    </label>
  </ng-container>
  <input
    *ngIf="identificationType() === 'email'"
    id="phoneOrEmail"
    type="text"
    formControlName="phoneOrEmail"
    (keyup.enter)="onSubmit()"
    class="flex w-full border border-solid border-neutral-300 bg-neutral-50 px-5 py-8xs font-base text-base font-normal leading-5"
    [class.border-error-700]="
      phoneErrorMessage ||
      (form.controls.phoneOrEmail.errors &&
        (form.controls.phoneOrEmail.dirty || form.controls.phoneOrEmail.touched))
    "
  />
  @if (identificationType() === 'phoneNumber') {
    <app-kiosk-input-country-phone-atom
      id="phoneOrEmail"
      [phone]="form.controls.phoneOrEmail.value"
      [useLocalFormat]="useLocalFormat()"
      [defaultRegionCode]="comoPlugin()?.phone_number_default_region_code ?? 'fr'"
      (updatePhone)="form.controls.phoneOrEmail.setValue($event)"
    />
  }
  <ng-container
    *ngIf="
      form.controls?.phoneOrEmail?.invalid &&
      (form.controls?.phoneOrEmail?.dirty || form.controls?.phoneOrEmail?.touched)
    "
  >
    <span
      class="absolute bottom-1 block font-base text-xs font-normal text-error-700"
      *ngIf="form.controls?.phoneOrEmail?.errors"
      translate="signup.invalid-phone"
    ></span>
  </ng-container>
  <ng-container *ngIf="phoneErrorMessage">
    <span
      class="font-base text-xs font-normal text-error-700"
      [translate]="phoneErrorMessage"
    ></span>
  </ng-container>
</form>

<div class="flex flex-col gap-2">
  <div
    *ngIf="errorMessage"
    class="self-center font-base text-xs font-normal text-error-700"
  >
    {{ errorMessage }}
  </div>
  <div class="flex flex-col gap-8">
    <div class="w-full">
      <app-button-atom
        [iconUrl]="isValidating ? 'assets/images/spinner.svg' : ''"
        [disabled]="isValidating || this.form.invalid"
        size="M"
        [label]="'como.create-or-link-account.identification-step.validate-button' | translate"
        type="primary"
        [full]="true"
        (click)="onSubmit()"
      ></app-button-atom>
    </div>
    <div class="w-full">
      <app-button-atom
        [label]="
          'como.create-or-link-account.identification-step.continue-without-loyalty-button'
            | translate
        "
        [full]="true"
        (click)="onContinueWithoutLoyalty()"
        size="M"
        type="light"
      ></app-button-atom>
    </div>
  </div>
</div>
